import { useState, useEffect } from 'react'
import './appetize.css'
import { useDemoContext } from '../DemoContext';
import { Box, Button, CircularProgress, Dialog, Select, Typography } from '@okta/odyssey-react-mui';
import { FingerprintOutlined, SettingsOutlined } from '@mui/icons-material';
import { Container } from '@mui/material';

const Appetize = () => {

    const demoContext = useDemoContext()
    const [demoParams, setDemoParams] = useState()
    const [application, setApplication] = useState()
    const [device, setDevice] = useState('pixel8pro')
    const [osVersion, setOsVersion] = useState('14.0')
    const [isOpen, setIsOpen] = useState(false) 

    useEffect(() => {
        if(demoContext?.demo?.settings?.appetize_id){
            setApplication(demoContext.demo.settings.appetize_id)
        }
        if(demoContext?.demo?.settings && demoContext?.demo?.oidc_configuration){
            var demoParams = {...demoContext.demo.settings}
            demoParams.issuer = demoContext.demo.oidc_configuration?.issuer
            demoParams.client_id = demoContext.demo.oidc_configuration?.client_id
            setDemoParams(encodeURIComponent(JSON.stringify(demoParams)))
        }
        
    },[demoContext,demoContext.demo])

    if(!demoContext.demoName){
        return(
            <Container sx={{alignItems: 'center', justifyItems: 'center'}}>
                <Typography variant='legend'>Demo name not set</Typography>
                <Typography variant='support'>Ensure you are launching from demo.okta.com</Typography>
            </Container>
        )
    }
    if(!demoContext.app){
        return(
            <Container sx={{alignItems: 'center', justifyItems: 'center'}}>
                <Typography variant='legend'>Application ID not set</Typography>
                <Typography variant='support'>Ensure you are launching from demo.okta.com</Typography>
            </Container>
        )
    }
    if (demoContext.demo){
        return (     
            <div className="appetizeContainer">
                <iframe 
                    className="emulator" title="appetize" id="app_iframe"
                    src={`https://appetize.io/embed/${application}?device=${device}&xdocMsg=true&osVersion=${osVersion}&scale=auto&centered=both&params=${demoParams}`}>
                </iframe>
                <Box className='deviceControls' sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
                    <Button
                        startIcon={<FingerprintOutlined/>}
                        label='Simulate biometric match'
                        onClick={async () => {document.getElementById("app_iframe").contentWindow.postMessage('biometryMatch', '*')}}
                    />
                    <Button onClick={() => {setIsOpen(true)}} label='Device Settings' variant='secondary' startIcon={<SettingsOutlined/>}/>
                    <Dialog title='Device Settings' isOpen={isOpen} onClose={() => {setIsOpen(false)}}>
                        <Select options={[{ value:'pixel9pro',text:'Pixel 9 Pro'},{value:'pixel8pro',text:'Pixel 8 Pro'},{value:'pixel7pro',text:'Pixel 7 Pro'}]}
                            label='Device'
                            value={device}
                            onChange={(e) => {setDevice(e.target.value)}}
                        />
                        <Select options={['15.0','14.0','13.0']}
                            label='OS Version'
                            value={osVersion}
                            onChange={(e) => {setOsVersion(e.target.value)}}
                        />
                    </Dialog>
                </Box>
            </div>
        );
    } else {
        if(demoContext.error){
            return(
            <Container sx={{alignItems: 'center', justifyItems: 'center'}}>
                <Typography variant='legend'>Something went wrong</Typography>
                {demoContext.error}
            </Container>
            )
        } else{
            return(
                <Container sx={{alignItems: 'center', justifyItems: 'center'}}>
                    <CircularProgress/>
                    <Typography variant='support'>Loading</Typography>
                </Container>
            )
        }
    }
};
export default Appetize;
